import "./index.scss";
import "./index.css";

import { ApiProvider } from "@reduxjs/toolkit/dist/query/react";
import App from "./App";
import { BreakpointProvider } from "react-socks";
import { BrowserRouter } from "react-router-dom";
import React from "react";
import ReactDOM from "react-dom/client";
import { homeSlice } from "./redux/slices/homeSlice";
import { store, persistor } from "./redux/store/store";
import { Provider } from "react-redux";
import { SkeletonTheme } from "react-loading-skeleton";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { PersistGate } from 'redux-persist/integration/react';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BreakpointProvider>
          <SkeletonTheme
            baseColor="#EDE5DE"
            // baseColor="#F8F4F1"
            highlightColor="#fff"
          >
            <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}>
              <App />
            </GoogleReCaptchaProvider>
          </SkeletonTheme>
        </BreakpointProvider>
      </PersistGate>
    </Provider>
  </BrowserRouter>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
